import CoborrowerBusinessTab from './CoborrowerBusinessTab'
export default CoborrowerBusinessTab